import { hbs } from 'ember-cli-htmlbars';
export default hbs('<a class=\"o--btn tPR--planFeature__action switchPlan\">\n  {{t \"account.change_plan.switch_to_this\"}}\n</a>', { moduleName: 'later/templates/change-plan/switch-plan.hbs' });
